<template>
  <div>
    <NavBar
      :codart="codArticulo"
      :catart="catArt(codArticulo)"
      :scat="SubCatArtCod(codArticulo)"
      :scatart="SubCatArt(codArticulo)"
      :cat="catnbArt(codArticulo)"
      :web="isWeb(codArticulo)"
    />

    <NavFicha
      :despiece="despieceArt(codArticulo)"
      :tipoart="TipoProd(codArticulo)"
    />

    <v-container
      grid-list-md
      :class="['mx-auto', 'mb-12', 'mt-0']"
      style="max-width: 1140px"
      v-scroll="onScroll"
    >
      <Loading v-if="Articulo.length === 0" />

      <v-layout row wrap v-if="Articulo.length === 0">
        <v-flex xs12>
          <v-card class="mx-auto" flat>
            <v-list-item three-line>
              <v-skeleton-loader
                fade-transition
                height="350"
                width="450"
                type="card"
                elevation="0"
              ></v-skeleton-loader>
              <v-list-item-content>
                <v-list-item-title>
                  <div class="d-flex flex-column mb-6">
                    <v-card v-for="n in 5" :key="n" flat tile>
                      <v-skeleton-loader
                        fade-transition
                        width="400"
                        type="list-item"
                        elevation="0"
                      ></v-skeleton-loader>
                    </v-card>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-actions>
              <v-skeleton-loader
                fade-transition
                width="650"
                type="list-item"
                elevation="0"
              ></v-skeleton-loader>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-else>
        <v-flex xs12 sm5 md5 lg5 xl5>
          <v-card flat>
            <imgDetArt :codart="codArticulo" />
          </v-card>
        </v-flex>

        <v-flex
          xs12
          sm7
          md7
          lg7
          xl7
          :class="[
            {
              'd-flex align-center mb-6': !dataUser.IndAutenticado,
            },
          ]"
        >
          <v-card flat width="100%">
            <v-card-title>
              REF: {{ codigoArt(codArticulo) }}

              <span class="d-flex ml-3">
                <v-img
                  :src="`${domoapi2_img}Marca-deco/${Articulo[0].Marca}/Alto-30?i=${updateImg}&Cia=15`"
                  class="img_art"
                ></v-img>
              </span>
              <pagArt
                v-if="$vuetify.breakpoint.mdAndUp"
                :codArt="codArticulo"
              />
            </v-card-title>
            <v-card-text
              class="mt-n3"
            >
              <div v-html="nombreArt(codArticulo,n-1)"  v-for="n in 4" :key="n"></div>
            </v-card-text>
            

            <v-card-text
              class="mt-n5"
              v-if="
                visiblePrecio({
                  articulo: Articulo[0],
                  usuario: dataUser,
                  arrcat: [1018],
                  arrsubcat: [30, 40],
                })
              "
            >
              <strong class="font-weight-bold black--text text--lighten-1">
                TRANSFERENCIA AUTOMATICA SE VENDE POR SEPARADO
              </strong>
            </v-card-text>

            <v-divider class="ml-3" color="#E0E0E0"></v-divider>
            <v-card-text
              class="mt-2"
              v-if="
                visiblePrecio({
                  articulo: Articulo[0],
                  usuario: dataUser,
                  arrcat: [1018, 1014],
                  arrsubcat: [30, 40],
                }) && dataUser.IndAutenticado
              "
            >
              <strong class="font-weight-medium">
                CONSULTAR CON SU EJECUTIVO DE CUENTA
              </strong>
            </v-card-text>
            <v-card-text>
              <div
                class="mt-n3 font-weight-medium"
                v-if="
                  !visiblePrecio({
                    articulo: Articulo[0],
                    usuario: dataUser,
                    arrcat: [1018, 1014],
                    arrsubcat: [30, 40],
                  }) &&
                  dataUser.IndAutenticado &&
                  dataUser.VerPrecios[tipoMoneda]
                "
              >
                <span
                  :class="[
                    'text-uppercase font-weight-bold logomoneda',
                    'mt-0',
                    'ml-0',
                  ]"
                >
                  <span
                    :class="[
                      {
                        'text-decoration-line-through text--secondary':
                          statusPromo(codArticulo, codArtPromo),
                      },
                    ]"
                  >
                    {{ TipoPrecio(codArticulo) }}
                    {{ simboloMoneda[tipoMoneda] }}
                  </span>
                  <span
                    :class="[
                      {
                        'font-weight-medium text-decoration-line-through text--secondary':
                          statusPromo(codArticulo, codArtPromo),
                      },
                    ]"
                  >
                    {{
                      (promoArt(codArticulo) === true ||
                      promoArt(codArticulo) === false
                        ? precioExtArt(codArticulo)
                        : 0) | numeral("0,0.00")
                    }}
                  </span>
                  <span
                    :class="[
                      {
                        'text-uppercase text--secondary': statusPromo(
                          codArticulo,
                          codArtPromo
                        ),
                      },
                    ]"
                  >
                    {{
                      condIva(codArticulo) === 0
                        ? "| Exento de IVA"
                        : "| No incluye IVA"
                    }}
                  </span>
                </span>
                <span
                  v-if="
                    promoArt(codArticulo) &&
                    statusPromo(codArticulo, codArtPromo)
                  "
                  :class="['font-weight-bold', 'logomoneda', 'mt-0', 'ml-0']"
                >
                  <br />
                  <span class="font-weight-bold mt-0 ml-0">
                    {{ TipoPrecio(codArticulo) }}
                    {{ simboloMoneda[tipoMoneda] }}
                  </span>
                  {{
                    (promoArt(codArticulo)
                      ? precioPromo(
                          codArticulo,
                          promoDetalleArt[
                            idpromo(promoDetalleArt) > 1
                              ? idpromo(promoDetalleArt) - 1
                              : 0
                          ].codigo
                        )
                      : 0) | numeral("0,0.00")
                  }}

                  <v-slide-y-transition name="fade">
                    <span
                      v-if="dataUser.IndAutenticado"
                      class="text-uppercase font-weight-bold mt-0 ml-0"
                      :class="[
                        $vuetify.breakpoint.mdAndUp
                          ? 'text-truncate text-uppercase font-weight-bold ml-0'
                          : 'text-truncate text-uppercase font-weight-bold title ml-1',
                      ]"
                    >
                      {{
                        precioPromo(
                          codArticulo,
                          promoDetalleArt[
                            idpromo(promoDetalleArt) > 1
                              ? idpromo(promoDetalleArt) - 1
                              : 0
                          ].codigo
                        )
                          ? "| Descuento: " +
                            montoDescuento(
                              codArticulo,
                              promoDetalleArt[
                                idpromo(promoDetalleArt) > 1
                                  ? idpromo(promoDetalleArt) - 1
                                  : 0
                              ].codigo
                            ) +
                            "%"
                          : ""
                      }}
                    </span>
                  </v-slide-y-transition>
                </span>
              </div>
              <div
                class="font-weight-medium title mt-0"
                v-if="
                  dataUser.IndAutenticado && dataUser.VerPrecios[tipoMoneda]
                "
              >
                {{
                  disponibleTxt(codArticulo) === "Disponible:"
                    ? `${disponibleTxt(codArticulo).toUpperCase()} ${contenidoMayor({
                        item: Articulo[0],
                      })} `
                    : disponibleTxt(codArticulo)
                }}
                <Paleta v-if="Articulo[0].UniVenta === `M2`"  class="ml-1 mr-1" />
                <Paquete v-if="Articulo[0].UniVenta !== `M2`" class="ml-1 mr-1" />
                <span
                  v-html="
                    formatNumber({
                      num: Articulo[0].DisponNum,
                      univenta: Articulo[0].UniVenta,
                    }) + subValue({ cod: Articulo[0].UniVenta })
                  "
                />
              </div>

              <btnAdd
                class="mt-4 ml-2"
                :selcliente="Cliente.showOpc"
                :userAuth="dataUser.IndAutenticado"
                :codArt="codArticulo"
                :promo="promoArt(codArticulo)"
                color="transparent"
                @promoArticulo="newCant"
                :tipoConsulta="2"
                :item="Articulo[0]"
                :ver="true"
                :textbtn="`agregar`"
              />

              <v-row v-if="promoArt(codArticulo) === true">
                <v-col cols="12" xl="10" lg="10" md="10" sm="10">
                  <v-simple-table class="mt-2" dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th
                            class="
                              text-center
                              body-2
                              font-weight-bold
                              text-uppercase
                            "
                          >
                            Descripción
                          </th>
                          <th
                            class="
                              text-center
                              body-2
                              font-weight-bold
                              text-uppercase
                            "
                          >
                            Precio
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(item, i) in detallePromocion(codArticulo)"
                        :key="i"
                      >
                        <tr>
                          <td class="text-left">
                            <span class="font-weight-bold ml-n3">
                              {{
                                `${
                                  $vuetify.breakpoint.mdAndUp
                                    ? "REFERENCIA:"
                                    : "REF:"
                                }`
                              }}
                            </span>
                            {{ codigoArt(codArticulo) }}
                          </td>
                          <td
                            v-if="dataUser.VerPrecios[tipoMoneda]"
                            class="
                              text-decoration-line-through
                              body-2
                              text-right
                              font-weight-bold
                            "
                          >
                            {{ simboloMoneda[tipoMoneda] }}
                            {{ precioExtArt(codArticulo) | numeral("0,0.00") }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">
                            <span class="font-weight-bold ml-n3">
                              {{
                                `${
                                  $vuetify.breakpoint.mdAndUp
                                    ? "DESCUENTO:"
                                    : "DESCTO:"
                                }`
                              }}
                            </span>
                            {{ item.descuento }} %
                          </td>
                          <td
                            v-if="dataUser.VerPrecios[tipoMoneda]"
                            class="text-right font-weight-bold body-1"
                          >
                            {{ simboloMoneda[tipoMoneda] }}
                            {{ item["PrecioExt-paq"] | numeral("0,0.00") }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">
                            <span class="font-weight-bold ml-n3">
                              {{
                                `${
                                  $vuetify.breakpoint.mdAndUp
                                    ? "CANT MINIMA:"
                                    : "CANT MIN:"
                                }`
                              }}
                            </span>
                            {{ item.Cantidad }}
                          </td>
                          <td class="text-right">
                            <btnPromo
                              v-if="
                                !visiblePrecio({
                                  articulo: Articulo[0],
                                  usuario: dataUser,
                                  arrcat: [1018, 1014],
                                  arrsubcat: [30, 40],
                                })
                              "
                              :infoproducto="Articulo[0]"
                              @sel-promo="cantPromo"
                              :codArt="codArticulo"
                              :codPromo="item.codigo"
                              :tipoConsulta="2"
                              :titulo="`${
                                $vuetify.breakpoint.mdAndUp
                                  ? 'CARGAR PROMOCIÓN'
                                  : 'CARGAR PROMO..'
                              }`"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
            /* <InfoExistencia
              class="mx-3"
              :msg="notaExist"
              v-if="disponibleNum(codArticulo) <= 1 && dataUser.IndAutenticado"
            /> */
          </v-card>
        </v-flex>
        <v-flex xs12 class="d-none">
          <miniview :codArt="codArticulo" />
        </v-flex>
        <v-flex xs12>
          <!-- paginacion mobile -->

          <NavFichaF
            v-if="fab === false"
            :despiece="despieceArt(codArticulo)"
            :tipoart="TipoProd(codArticulo)"
          />
        </v-flex>
        <v-flex xs12 id="Feature" v-if="dsCaracteristicas.ttinmaecar">
          <v-card flat>
            <v-card-title class="headline primary--text text--lighten-1">
              Características
            </v-card-title>
            <v-divider color="#E0E0E0" class="mt-n3"></v-divider>
            <Feature />
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-if="
            Object.entries(EspecifTecnica).length !== 0 &&
            dataUser.IndAutenticado
          "
          id="Ficha"
        >
          <v-card flat>
            <v-card-title class="headline primary--text text--lighten-1">
              Ficha Técnica

              <pdfFicha
                :despieceFile="despieceFile(codArticulo)"
                :imgpdf="imgArtPdf(codArticulo)"
                :marcapdf="marcaLogoPdf(codArticulo)"
                :cod="codigoArt(codArticulo)"
                :nombreLg="`${nombreArt(
                  codArticulo,0
                )}                              
                            ${nombreArt(
                              codArticulo,1
                            )}                              
                            ${nombreArt(
                              codArticulo,2
                            )}                              
                            ${nombreArt(codArticulo,3)}`"
                :marca="marcaLogo(codArticulo)"
                :img="imgArt2(codArticulo)"
                :datosTecnicos="EspecifTecnica"
              />
            </v-card-title>
            <v-divider color="#E0E0E0" class="mt-n3"></v-divider>
            <verFicha :datosTecnicos="EspecifTecnica" :tipovista="2" />
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="Object.entries(Seccion).length !== 0" id="Repuesto">
          <v-card flat>
            <v-card-title class="headline primary--text text--lighten-1">
              Repuestos
              <desPiece
                :despieceFile="despieceFile(codArticulo)"
                :despieceArt="despieceArt(codArticulo)"
                :codArt="codArticulo"
              />
            </v-card-title>
            <v-divider color="#E0E0E0" class="mt-n3"></v-divider>
            <verRep :datosRepuestos="Seccion" :tipovista="2"> </verRep>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          id="MaquinaRep"
          v-if="Object.entries(MaquinaRep).length !== 0"
        >
          <v-card flat>
            <v-card-title class="headline primary--text text--lighten-1">
              Maquinas
            </v-card-title>
            <v-divider color="#E0E0E0" class="mt-n3"></v-divider>

            <verMaquina />
          </v-card>
        </v-flex>
        <v-flex xs12 id="Manuals" v-show="isManual && false">
          <v-card flat>
            <v-card-title class="headline primary--text text--lighten-1">
              Manuales
            </v-card-title>
            <v-divider color="#E0E0E0" class="mt-n3"></v-divider>
            <verManual :codart="codArticulo" />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-btn v-scroll="onScroll" class="d-none"></v-btn>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

import NavBar from "../components/Navegacion";
import NavFicha from "../components/NavegacionFicha";
import NavFichaF from "../components/NavegacionFichaFijo";
import btnAdd from "../components/botonadd";
import btnPromo from "../components/botonselpromo";
import verFicha from "../components/ImprimirLoc";
import verRep from "../components/ImprimirRep";
import verMaquina from "../components/ImprimirMaq";
import verManual from "../components/Manuales";
import pdfFicha from "../components/Imprimir";
import imgDetArt from "../components/ImagenDetalleArt";
import Feature from "../components/ProductoFeature";
import desPiece from "../components/Despiece";
import pagArt from "../components/pagArt";
import miniview from "../components/miniView";
import { visiblePrecio } from "../static/funciones";
import { CarAdd, CarAddBtn } from "../components/CarAdd/";
import { InfoExistencia } from "./InfoExistencia";
import { Loading } from "./LoadingDomo";
import { Paleta, Paquete } from "./Icons";
export default {
  data() {
    return {
      currentSlide: 0,
      active: false,
      collapseOnScroll: false,
      tab: 0,
      cant: 1,
      fab: false,
      videoId: "P1-wYfj4aZs",
      item: 5,
      dialog: false,
      newCantArt: 0,
      tipoPromo: 0,
      promoDetalle: [],
      promoDetalleArt: [],
      cantMin: 1,
      codXart: false,
      codArtPromo: null,
      aws_url: process.env.AWS_URL,
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  components: {
    InfoExistencia,
    verManual,
    miniview,
    Feature,
    NavBar,
    NavFicha,
    NavFichaF,
    verFicha,
    verRep,
    btnAdd,
    btnPromo,
    imgDetArt,
    pdfFicha,
    desPiece,
    pagArt,
    verMaquina,
    CarAdd,
    CarAddBtn,
    Loading,
    Paleta,
    Paquete,
  },
  created() {
    this.GetManual();
    window.scrollTo(0, 0);
    //this.CLR_PROMO();
    this.CLR_ERROR_AXIOS();
    this.cargarDatosPromo({ codart: this.$route.params.codart });
    this.cargarDatosArt({ codart: this.$route.params.codart });
    this.cargarFeature({
      articulo: this.$route.params.codart,
      cia: 15,
      opc: 8,
      status: 1,
    });
    this.CLR_DATOS_ART();
  },
  computed: {
    ...mapState([
      "MaquinaRep",
      "Articulo",
      "notaExist",
      "EspecifTecnica",
      "PromocionAll",
      "Seccion",
      "Cliente",
      "simboloMoneda",
      "tipoMoneda",
      "dataUser",
      "TipoUsuario",
      "imgDetalle",
      "imgPeque",
      "imgMarcas",
      "NoImg",
      "DetalleArt",
      "PromocionCombo",
      "PromocionCant",
      "dsCaracteristicas",
      "domoapi2_img",
      "filter",
    ]),
    ...mapGetters(["filterpromoart", "filterconsolidado", "isManual"]),
    subValue: function () {
      return function ({ cod }) {
        if (cod === "M2") {
          const numero = cod.slice(1); // Extrae el "2"
          const character = cod.slice(0, 1).toLowerCase(); // Extrae el "M"
          return `${character}<sup>${numero}</sup>`; // Formatea como "M<sup>2</sup>"
        } else return cod;
      };
    },
    validaContenido() {
      const { ContentDetal } = this.item;
      return ContentDetal !== 1;
    },
    contenidoMayor: function () {
      return function ({ item: { DisponNum, ContentMayor } }) {
        let division = Math.trunc(DisponNum / ContentMayor);

        return division;
      };
    },

    detallePromocion: function () {
      //articulo
      return function (id) {
        if (this.filterpromoart) {
          return this.filterpromoart.filter((x) => id === x["articulo"]);
        }
      };
    },
    idpromo: function () {
      return function (a) {
        return a ? a.length : 0;
      };
    },
    statusPromo: function () {
      return function (a, b) {
        return a === b ? this.codXart : false;
      };
    },
    precioNuevo: function () {
      return function (codp, codp2, cantmin) {
        let nb = true;
        let cantminpromo;
        let numpromo = 0;
        if (codp === codp2) {
          this.PromocionAll.forEach((item) => {
            if (codp === item["articulo"]) numpromo++;
          });
          //1 sola promocion
          if (numpromo === 1) {
            cantminpromo = this.PromocionAll.filter((x) => x["codigo"] === codp)
              .map((x) => x["cantidad-min"])
              .toString();
            if (cantmin < cantminpromo) nb = false;
            else nb = true;
          }
          //mas de una promocion
          if (numpromo > 1) {
            let cp = [];
            this.PromocionAll.forEach((item) => {
              if (codp === item["articulo"])
                cp.push({
                  cantminart: item["cantidad-min"],
                  codpromo: item["codigo"],
                  articulo: item["articulo"],
                });
            });

          }
        }

        return nb;
      };
    },
    codArticulo: {
      get: function () {
        return this.$route.params.codart;
      },
    },
    fichaContenido: function () {
      return function (id) {
        if (this.EspecifTecnica)
          return this.EspecifTecnica.filter(
            (x) => x.Grupo === id && x.Valor != ""
          );
      };
    },
    imgArticulo: function () {
      return function (id) {
        if (this.Seccion)
          return this.Seccion.filter((x) => x.CodSeccion === id);
      };
    },
    marcaDir: {
      get: function () {
        return this.imgMarca;
      },
    },
    //Categoria
    marcaLogoPdf: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Marca
          );
          if (nb != "") return `${nb.toString()}.jpg`;
        }
      };
    },
    marcaLogo: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Marca
          );
          if (nb != "") return `${this.imgMarcas}${nb.toString()}.jpg`;
        }
      };
    },
    catArt: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Categoria)
            .toString();
        }
      };
    },
    SubCatArt: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.NombreSubCat)
            .toString();
        }
      };
    },
    isWeb: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Web
          )[0];
        }
      };
    },
    SubCatArtCod: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.SubCategoria
          )[0];
        }
      };
    },
    despieceFile: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Despiece)
            .toString();
        }
      };
    },
    despieceArt: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Despiece)
            .toString();
        }
      };
    },
    catnbArt: function () {
      return function (id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.NombreCat)
            .toString();
        }
      };
    },
    imagenArtSrc: {
      get: function () {
        return this.imgDir;
      },
    },
    youtubeSrc: {
      get: function () {
        return `https://www.youtube.com/embed/${this.videoId}`;
      },
    },
    //DisponNum
    disponibleNum: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.DisponNum
          );
          return this.dataUser.IndAutenticado === true ? nb.toString() : "";
        }
      };
    },
    disponibleTxt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.DisponTxt
          );
          return this.dataUser.IndAutenticado === true ? nb.toString() : "";
        }
      };
    },
    disponibleArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Disponible
          );
          return this.dataUser.IndAutenticado === true ? nb.toString() : "";
        }
      };
    },
    cumplePromo: function () {
      return function (id) {
        if (this.PromocionAll) {
          this.PromocionAll.filter((x) => id >= x["cantidad-min"]);
          return 1;
        }
      };
    },
    ivaArt: function () {
      return function (id) {
        return this.dataUser.IndAutenticado === true
          ? id === 0
            ? " | Exento de IVA"
            : "| No incluye IVA"
          : "";
      };
    },
    condIva: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Iva
          );
          return nb[0];
        }
      };
    },
    marcaTxt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.NombreMarca
          );
          return nb.toString();
        }
      };
    },
    imgArt2: function () {
      let urlImg = null;
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Imagen
          );
          // icon: this.user.icon && require(`../assets/imgs/${this.user.icon}`)
          //${imgPeque}no_image.jpg
          if (nb != "") return `${this.imgPeque}${nb.toString()}`;
        }
        return urlImg;
      };
    },
    imgArtPdf: function () {
      let urlImg = null;
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Imagen
          );
          // icon: this.user.icon && require(`../assets/imgs/${this.user.icon}`)
          //${imgPeque}no_image.jpg
          if (nb != "") return `${nb.toString()}`;
        }
        return urlImg;
      };
    },
    promoArt: function () {
      return function (id) {
        var nb = false;
        if (this.Articulo) {
          nb = this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Promocion)
            .toString();
          return this.dataUser.IndAutenticado === true
            ? this.parseBool(nb)
            : "";
        }
        // return nb.toString();
      };
    },
    montoDescuento: function () {
      //item.MontoExtDes
      return function (id, codp) {
        let nb = null;
        if (this.PromocionAll) {
          this.PromocionAll.forEach((item) => {
            if (id === item["articulo"] && item.codigo === codp) {
              nb = item["descuento"];
            }
          });
          //return this.PromocionAll.filter(x =>x['articulo']===id).map(x =>x['descuento']).toString();
          return Number.parseFloat(nb);
        }
      };
    },
    precioPromo: function () {
      return function (id, codp) {
        if (this.PromocionAll) {
          let nb = this.PromocionAll.filter(
            (x) => x["articulo"] === id && x["codigo"] === codp
          ).map((x) => x["PrecioExt-paq"]);

          return this.dataUser.VerPrecios[this.tipoMoneda] === true ? nb : 0;
        } else return 0;
      };
    },

    precioExtArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Precio[this.tipoMoneda]
          );
          return this.dataUser.VerPrecios[this.tipoMoneda] === true ? nb : 0;
        }
      };
    },
    nombreArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Nombre
          );
          return nb.toString();
        }
      };
    },
    TipoPrecio: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.TipoPrecio
          );
          return nb.toString();
        }
      };
    },
    codigoArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Codigo
          );
          return nb.toString();
        }
      };
    },
    marcaArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Marca
          );
          return nb.toString() + ".jpg";
        }
      };
    },

    TipoProd: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.TipoProd
          );
          return nb.toString();
        }
      };
    },

    nombreArt: function () {
      return function (id, pos) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Detalle[pos]
          );
          return nb.toString();
        }
      };
    },


  },
  methods: {
    ...mapActions(["cargarDatosPromo", "cargarFeature", "cargarDatosArt"]),
    ...mapMutations([
      "SET_DATOS_ART",
      "SET_DATOS_ART_ET",
      "SET_DATOS_ART_SEC",
      "SET_DATOS_ART_PROM",
      "CLR_DATOS_SUBCAT",
      "CLR_ERROR_AXIOS",
      "CLR_DATOS_ART"
    ]),
    visiblePrecio,
    formatNumber({ num, univenta }) {
      let numeral = require("numeral");
      const formatNum = univenta !== "M2" ? "0,0" : "0,0.00";
      const result = numeral(num).format(formatNum);
      return result;
    },
    formatDispon(valor) {
      let numeral = require("numeral");
      let montoDispon = numeral(valor).format("0,0");
      return montoDispon;
    },
    iconDispon(valor) {
      return valor <= 1 ? "*" : "";
    },

    GetManual() {
      if (this.isManual) return this.isManual;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 80;
    },
    cantPromo(datos) {
      this.promoDetalle = datos;
    },
    newCant(datos, cant, status, cod) {
      this.promoDetalleArt = datos;
      this.cantMin = cant;
      this.codXart = status;
      this.codArtPromo = cod;
    },
    setAltImg(event) {
      event.target.src = `${this.NoImg}no_image.jpg`;
    },
    parseBool(str) {
      if (str.length == null) {
        return str == 1 ? true : false;
      } else {
        return str == "true" ? true : false;
      }
    },
  },
};
</script>

<style scoped>
.logomoneda {
  font-size: 1.2rem;
  vertical-align: top;
  line-height: 30px;
  margin: 0 5px;
  color: black;
}
.monedaant {
  font-size: 1.1rem;
  vertical-align: top;
  line-height: 30px;
  margin: 0 5px;
}
.inputdetalle {
  font-size: 2.4rem;
  line-height: 42px;
  border: 1px solid #ccc;
  text-align: center;
  font-weight: 700;
  float: left;
  border-radius: 0;
  box-shadow: none;
  margin: 0 15px 0 0;
  padding: 0;
  background: #fff;
  box-sizing: border-box;
}
.img_art {
  max-width: 100%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 20%;
}
.slide-fade-enter-active {
  transition: all 2s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>
